/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryChangeStatusRequest
 */
export interface RevisdomAPIViewModelsEntryChangeStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryChangeStatusRequest
     */
    entryStatus?: RevisdomAPIViewModelsEntryChangeStatusRequestEntryStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsEntryChangeStatusRequest
     */
    changeSubentries?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryChangeStatusRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryChangeStatusRequest
     */
    entryType?: RevisdomAPIViewModelsEntryChangeStatusRequestEntryTypeEnum;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryChangeStatusRequestEntryStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type RevisdomAPIViewModelsEntryChangeStatusRequestEntryStatusEnum = typeof RevisdomAPIViewModelsEntryChangeStatusRequestEntryStatusEnum[keyof typeof RevisdomAPIViewModelsEntryChangeStatusRequestEntryStatusEnum];

/**
 * @export
 */
export const RevisdomAPIViewModelsEntryChangeStatusRequestEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryChangeStatusRequestEntryTypeEnum = typeof RevisdomAPIViewModelsEntryChangeStatusRequestEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryChangeStatusRequestEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryChangeStatusRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryChangeStatusRequest(value: object): value is RevisdomAPIViewModelsEntryChangeStatusRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryChangeStatusRequestFromJSON(json: any): RevisdomAPIViewModelsEntryChangeStatusRequest {
    return RevisdomAPIViewModelsEntryChangeStatusRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryChangeStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryChangeStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entryStatus': json['entryStatus'] == null ? undefined : json['entryStatus'],
        'changeSubentries': json['changeSubentries'] == null ? undefined : json['changeSubentries'],
        'id': json['id'] == null ? undefined : json['id'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
    };
}

export function RevisdomAPIViewModelsEntryChangeStatusRequestToJSON(json: any): RevisdomAPIViewModelsEntryChangeStatusRequest {
    return RevisdomAPIViewModelsEntryChangeStatusRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryChangeStatusRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryChangeStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryStatus': value['entryStatus'],
        'changeSubentries': value['changeSubentries'],
        'id': value['id'],
        'entryType': value['entryType'],
    };
}

